/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "features/growth/v3/tracking/ui_interaction.proto" (package "fubo.tv.proto.features.growth.v3.tracking", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Cohorting } from "../../../../common/v3/generic/cohorting";
import { Growth } from "../../../../common/v3/generic/growth";
import { SubGrowth } from "../../../../common/v3/generic/sub_growth";
import { Location } from "../../../../common/v3/generic/location";
import { Source } from "../../../../common/v3/generic/source";
import { Device } from "../../../../common/v3/generic/device";
import { Channel } from "../../../../common/v3/generic/channel";
import { Asset } from "../../../../common/v3/generic/asset";
import { Genre } from "../../../../common/v3/generic/genre";
import { Team } from "../../../../common/v3/generic/team";
import { League } from "../../../../common/v3/generic/league";
import { Sport } from "../../../../common/v3/generic/sport";
import { Program } from "../../../../common/v3/generic/program";
import { Ui } from "../../../../common/v3/generic/ui";
import { Navigation } from "../../../../common/v3/generic/navigation";
import { AppContext } from "../../../../common/v3/generic/app_context";
import { UserProperties } from "../../../../common/v3/generic/user_properties";
import { FuboContext } from "../../../../common/v3/generic/fubo_context";
import { Core } from "../../../../common/v3/generic/core";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message fubo.tv.proto.features.growth.v3.tracking.UiInteraction
 */
export interface UiInteraction {
    /**
     * @generated from protobuf field: optional string anonymous_id = 1;
     */
    anonymous_id?: string;
    /**
     * @generated from protobuf field: fubo.tv.proto.features.growth.v3.tracking.UiInteraction.EventName event = 2;
     */
    event: UiInteraction_EventName;
    /**
     * @generated from protobuf field: string message_id = 3;
     */
    message_id: string;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp received_at = 4;
     */
    received_at?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sent_at = 5;
     */
    sent_at?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 6;
     */
    timestamp?: Timestamp;
    /**
     * @generated from protobuf field: string type = 7;
     */
    type: string;
    /**
     * @generated from protobuf field: optional string user_id = 8;
     */
    user_id?: string;
    /**
     * @generated from protobuf field: fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Properties properties = 9;
     */
    properties?: UiInteraction_Properties;
}
/**
 * @generated from protobuf message fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute
 */
export interface UiInteraction_Attribute {
    /**
     * @generated from protobuf field: fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute.EventCategory.EventCategoryValue event_category = 1;
     */
    event_category: UiInteraction_Attribute_EventCategory_EventCategoryValue;
    /**
     * @generated from protobuf field: fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute.EventSubCategory.EventSubCategoryValue event_sub_category = 2;
     */
    event_sub_category: UiInteraction_Attribute_EventSubCategory_EventSubCategoryValue;
}
/**
 * @generated from protobuf message fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute.EventCategory
 */
export interface UiInteraction_Attribute_EventCategory {
}
/**
 * @generated from protobuf enum fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute.EventCategory.EventCategoryValue
 */
export enum UiInteraction_Attribute_EventCategory_EventCategoryValue {
    /**
     * @generated from protobuf enum value: sign_in = 0;
     */
    sign_in = 0,
    /**
     * @generated from protobuf enum value: sign_up = 1;
     */
    sign_up = 1,
    /**
     * @generated from protobuf enum value: manage_account = 2;
     */
    manage_account = 2,
    /**
     * @generated from protobuf enum value: reset_password = 3;
     */
    reset_password = 3,
    /**
     * @generated from protobuf enum value: resubscribe_funnel = 4;
     */
    resubscribe_funnel = 4,
    /**
     * @generated from protobuf enum value: cancellation_funnel = 5;
     */
    cancellation_funnel = 5,
    /**
     * @generated from protobuf enum value: proactive_offer = 6;
     */
    proactive_offer = 6,
    /**
     * @generated from protobuf enum value: marketing = 7;
     */
    marketing = 7
}
/**
 * @generated from protobuf message fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute.EventSubCategory
 */
export interface UiInteraction_Attribute_EventSubCategory {
}
/**
 * @generated from protobuf enum fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute.EventSubCategory.EventSubCategoryValue
 */
export enum UiInteraction_Attribute_EventSubCategory_EventSubCategoryValue {
    /**
     * @generated from protobuf enum value: growth_cta = 0;
     */
    growth_cta = 0,
    /**
     * @generated from protobuf enum value: select_product = 1;
     */
    select_product = 1,
    /**
     * @generated from protobuf enum value: deselect_product = 2;
     */
    deselect_product = 2,
    /**
     * @generated from protobuf enum value: switched_to_upsell_offer = 3;
     */
    switched_to_upsell_offer = 3,
    /**
     * @generated from protobuf enum value: declined_upsell_offer = 4;
     */
    declined_upsell_offer = 4,
    /**
     * @generated from protobuf enum value: confirm_zip_code = 5;
     */
    confirm_zip_code = 5,
    /**
     * @generated from protobuf enum value: forgot_password = 6;
     */
    forgot_password = 6,
    /**
     * @generated from protobuf enum value: change_password = 7;
     */
    change_password = 7,
    /**
     * @generated from protobuf enum value: change_product = 8;
     */
    change_product = 8,
    /**
     * @generated from protobuf enum value: update_payment = 9;
     */
    update_payment = 9,
    /**
     * @generated from protobuf enum value: resubscribe_subscription = 10;
     */
    resubscribe_subscription = 10,
    /**
     * @generated from protobuf enum value: cancel_subscription = 11;
     */
    cancel_subscription = 11,
    /**
     * @generated from protobuf enum value: reactivate_subscription = 12;
     */
    reactivate_subscription = 12,
    /**
     * @generated from protobuf enum value: pause_subscription = 13;
     */
    pause_subscription = 13,
    /**
     * @generated from protobuf enum value: cancel_scheduled_pause = 14;
     */
    cancel_scheduled_pause = 14,
    /**
     * @generated from protobuf enum value: marketing = 15;
     */
    marketing = 15
}
/**
 * @generated from protobuf message fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Properties
 */
export interface UiInteraction_Properties {
    /**
     * @generated from protobuf field: fubo.tv.proto.common.v3.generic.Core core = 1;
     */
    core?: Core;
    /**
     * @generated from protobuf field: fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute attribute = 2;
     */
    attribute?: UiInteraction_Attribute;
    /**
     * @generated from protobuf field: fubo.tv.proto.common.v3.generic.FuboContext fubo_context = 3;
     */
    fubo_context?: FuboContext;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.UserProperties user_properties = 4;
     */
    user_properties?: UserProperties;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.AppContext app_context = 5;
     */
    app_context?: AppContext;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Navigation navigation = 6;
     */
    navigation?: Navigation;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Ui ui = 7;
     */
    ui?: Ui;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Program program = 8;
     */
    program?: Program;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Sport sport = 9;
     */
    sport?: Sport;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.League league = 10;
     */
    league?: League;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Team team = 11;
     */
    team?: Team;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Genre genre = 12;
     */
    genre?: Genre;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Asset asset = 13;
     */
    asset?: Asset;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Channel channel = 14;
     */
    channel?: Channel;
    /**
     * @generated from protobuf field: fubo.tv.proto.common.v3.generic.Device device = 15;
     */
    device?: Device;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Source source = 16;
     */
    source?: Source;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Location location = 17;
     */
    location?: Location;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.SubGrowth sub_growth = 18;
     */
    sub_growth?: SubGrowth;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Growth growth = 19;
     */
    growth?: Growth;
    /**
     * @generated from protobuf field: repeated fubo.tv.proto.common.v3.generic.Cohorting cohorting = 20;
     */
    cohorting: Cohorting[];
}
/**
 * @generated from protobuf enum fubo.tv.proto.features.growth.v3.tracking.UiInteraction.EventName
 */
export enum UiInteraction_EventName {
    /**
     * @generated from protobuf enum value: ui_interaction = 0;
     */
    ui_interaction = 0
}
// @generated message type with reflection information, may provide speed optimized methods
class UiInteraction$Type extends MessageType<UiInteraction> {
    constructor() {
        super("fubo.tv.proto.features.growth.v3.tracking.UiInteraction", [
            { no: 1, name: "anonymous_id", kind: "scalar", localName: "anonymous_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "c6ced3d1-694c-4658-83a6-719f6cdcfb47", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "A pseudo-unique substitute for a User ID, for cases when you don\u2019t have an absolutely unique identifier, an anonymous_id or a user_id is required." } },
            { no: 2, name: "event", kind: "enum", T: () => ["fubo.tv.proto.features.growth.v3.tracking.UiInteraction.EventName", UiInteraction_EventName], options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "ui_interaction", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Event name." } },
            { no: 3, name: "message_id", kind: "scalar", localName: "message_id", T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "6ac0e185-427b-40fb-b213-e624d0c1b3e0", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "A unique identifier for each message that lets you find an individual message across the API." } },
            { no: 4, name: "received_at", kind: "message", localName: "received_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Timestamp of receiving event in RFC 3339 format, enriched by Ingestion Backend" } },
            { no: 5, name: "sent_at", kind: "message", localName: "sent_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Timestamp of sending event in RFC 3339 format." } },
            { no: 6, name: "timestamp", kind: "message", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Timestamp of event in RFC 3339 format." } },
            { no: 7, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "track", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Type of message, track or identify." } },
            { no: 8, name: "user_id", kind: "scalar", localName: "user_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "1234567891011", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Unique identifier for the user, an anonymous_id or a user_id is required." } },
            { no: 9, name: "properties", kind: "message", T: () => UiInteraction_Properties }
        ], { "fubo.tv.proto.common.v3.custom.bigquery_opts": { tableName: "ui_interaction" } });
    }
    create(value?: PartialMessage<UiInteraction>): UiInteraction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.event = 0;
        message.message_id = "";
        message.type = "";
        if (value !== undefined)
            reflectionMergePartial<UiInteraction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UiInteraction): UiInteraction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string anonymous_id */ 1:
                    message.anonymous_id = reader.string();
                    break;
                case /* fubo.tv.proto.features.growth.v3.tracking.UiInteraction.EventName event */ 2:
                    message.event = reader.int32();
                    break;
                case /* string message_id */ 3:
                    message.message_id = reader.string();
                    break;
                case /* optional google.protobuf.Timestamp received_at */ 4:
                    message.received_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.received_at);
                    break;
                case /* google.protobuf.Timestamp sent_at */ 5:
                    message.sent_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.sent_at);
                    break;
                case /* google.protobuf.Timestamp timestamp */ 6:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* string type */ 7:
                    message.type = reader.string();
                    break;
                case /* optional string user_id */ 8:
                    message.user_id = reader.string();
                    break;
                case /* fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Properties properties */ 9:
                    message.properties = UiInteraction_Properties.internalBinaryRead(reader, reader.uint32(), options, message.properties);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UiInteraction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string anonymous_id = 1; */
        if (message.anonymous_id !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.anonymous_id);
        /* fubo.tv.proto.features.growth.v3.tracking.UiInteraction.EventName event = 2; */
        if (message.event !== 0)
            writer.tag(2, WireType.Varint).int32(message.event);
        /* string message_id = 3; */
        if (message.message_id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.message_id);
        /* optional google.protobuf.Timestamp received_at = 4; */
        if (message.received_at)
            Timestamp.internalBinaryWrite(message.received_at, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp sent_at = 5; */
        if (message.sent_at)
            Timestamp.internalBinaryWrite(message.sent_at, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp timestamp = 6; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string type = 7; */
        if (message.type !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.type);
        /* optional string user_id = 8; */
        if (message.user_id !== undefined)
            writer.tag(8, WireType.LengthDelimited).string(message.user_id);
        /* fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Properties properties = 9; */
        if (message.properties)
            UiInteraction_Properties.internalBinaryWrite(message.properties, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.features.growth.v3.tracking.UiInteraction
 */
export const UiInteraction = new UiInteraction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UiInteraction_Attribute$Type extends MessageType<UiInteraction_Attribute> {
    constructor() {
        super("fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute", [
            { no: 1, name: "event_category", kind: "enum", localName: "event_category", T: () => ["fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute.EventCategory.EventCategoryValue", UiInteraction_Attribute_EventCategory_EventCategoryValue], options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "sign_in", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "???" } },
            { no: 2, name: "event_sub_category", kind: "enum", localName: "event_sub_category", T: () => ["fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute.EventSubCategory.EventSubCategoryValue", UiInteraction_Attribute_EventSubCategory_EventSubCategoryValue], options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "select_product", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "???" } }
        ]);
    }
    create(value?: PartialMessage<UiInteraction_Attribute>): UiInteraction_Attribute {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.event_category = 0;
        message.event_sub_category = 0;
        if (value !== undefined)
            reflectionMergePartial<UiInteraction_Attribute>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UiInteraction_Attribute): UiInteraction_Attribute {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute.EventCategory.EventCategoryValue event_category */ 1:
                    message.event_category = reader.int32();
                    break;
                case /* fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute.EventSubCategory.EventSubCategoryValue event_sub_category */ 2:
                    message.event_sub_category = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UiInteraction_Attribute, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute.EventCategory.EventCategoryValue event_category = 1; */
        if (message.event_category !== 0)
            writer.tag(1, WireType.Varint).int32(message.event_category);
        /* fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute.EventSubCategory.EventSubCategoryValue event_sub_category = 2; */
        if (message.event_sub_category !== 0)
            writer.tag(2, WireType.Varint).int32(message.event_sub_category);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute
 */
export const UiInteraction_Attribute = new UiInteraction_Attribute$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UiInteraction_Attribute_EventCategory$Type extends MessageType<UiInteraction_Attribute_EventCategory> {
    constructor() {
        super("fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute.EventCategory", []);
    }
    create(value?: PartialMessage<UiInteraction_Attribute_EventCategory>): UiInteraction_Attribute_EventCategory {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UiInteraction_Attribute_EventCategory>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UiInteraction_Attribute_EventCategory): UiInteraction_Attribute_EventCategory {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UiInteraction_Attribute_EventCategory, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute.EventCategory
 */
export const UiInteraction_Attribute_EventCategory = new UiInteraction_Attribute_EventCategory$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UiInteraction_Attribute_EventSubCategory$Type extends MessageType<UiInteraction_Attribute_EventSubCategory> {
    constructor() {
        super("fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute.EventSubCategory", []);
    }
    create(value?: PartialMessage<UiInteraction_Attribute_EventSubCategory>): UiInteraction_Attribute_EventSubCategory {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UiInteraction_Attribute_EventSubCategory>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UiInteraction_Attribute_EventSubCategory): UiInteraction_Attribute_EventSubCategory {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UiInteraction_Attribute_EventSubCategory, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute.EventSubCategory
 */
export const UiInteraction_Attribute_EventSubCategory = new UiInteraction_Attribute_EventSubCategory$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UiInteraction_Properties$Type extends MessageType<UiInteraction_Properties> {
    constructor() {
        super("fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Properties", [
            { no: 1, name: "core", kind: "message", T: () => Core },
            { no: 2, name: "attribute", kind: "message", T: () => UiInteraction_Attribute },
            { no: 3, name: "fubo_context", kind: "message", localName: "fubo_context", T: () => FuboContext },
            { no: 4, name: "user_properties", kind: "message", localName: "user_properties", T: () => UserProperties },
            { no: 5, name: "app_context", kind: "message", localName: "app_context", T: () => AppContext },
            { no: 6, name: "navigation", kind: "message", T: () => Navigation },
            { no: 7, name: "ui", kind: "message", T: () => Ui },
            { no: 8, name: "program", kind: "message", T: () => Program },
            { no: 9, name: "sport", kind: "message", T: () => Sport },
            { no: 10, name: "league", kind: "message", T: () => League },
            { no: 11, name: "team", kind: "message", T: () => Team },
            { no: 12, name: "genre", kind: "message", T: () => Genre },
            { no: 13, name: "asset", kind: "message", T: () => Asset },
            { no: 14, name: "channel", kind: "message", T: () => Channel },
            { no: 15, name: "device", kind: "message", T: () => Device },
            { no: 16, name: "source", kind: "message", T: () => Source },
            { no: 17, name: "location", kind: "message", T: () => Location },
            { no: 18, name: "sub_growth", kind: "message", localName: "sub_growth", T: () => SubGrowth },
            { no: 19, name: "growth", kind: "message", T: () => Growth },
            { no: 20, name: "cohorting", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Cohorting }
        ]);
    }
    create(value?: PartialMessage<UiInteraction_Properties>): UiInteraction_Properties {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cohorting = [];
        if (value !== undefined)
            reflectionMergePartial<UiInteraction_Properties>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UiInteraction_Properties): UiInteraction_Properties {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* fubo.tv.proto.common.v3.generic.Core core */ 1:
                    message.core = Core.internalBinaryRead(reader, reader.uint32(), options, message.core);
                    break;
                case /* fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute attribute */ 2:
                    message.attribute = UiInteraction_Attribute.internalBinaryRead(reader, reader.uint32(), options, message.attribute);
                    break;
                case /* fubo.tv.proto.common.v3.generic.FuboContext fubo_context */ 3:
                    message.fubo_context = FuboContext.internalBinaryRead(reader, reader.uint32(), options, message.fubo_context);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.UserProperties user_properties */ 4:
                    message.user_properties = UserProperties.internalBinaryRead(reader, reader.uint32(), options, message.user_properties);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.AppContext app_context */ 5:
                    message.app_context = AppContext.internalBinaryRead(reader, reader.uint32(), options, message.app_context);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Navigation navigation */ 6:
                    message.navigation = Navigation.internalBinaryRead(reader, reader.uint32(), options, message.navigation);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Ui ui */ 7:
                    message.ui = Ui.internalBinaryRead(reader, reader.uint32(), options, message.ui);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Program program */ 8:
                    message.program = Program.internalBinaryRead(reader, reader.uint32(), options, message.program);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Sport sport */ 9:
                    message.sport = Sport.internalBinaryRead(reader, reader.uint32(), options, message.sport);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.League league */ 10:
                    message.league = League.internalBinaryRead(reader, reader.uint32(), options, message.league);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Team team */ 11:
                    message.team = Team.internalBinaryRead(reader, reader.uint32(), options, message.team);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Genre genre */ 12:
                    message.genre = Genre.internalBinaryRead(reader, reader.uint32(), options, message.genre);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Asset asset */ 13:
                    message.asset = Asset.internalBinaryRead(reader, reader.uint32(), options, message.asset);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Channel channel */ 14:
                    message.channel = Channel.internalBinaryRead(reader, reader.uint32(), options, message.channel);
                    break;
                case /* fubo.tv.proto.common.v3.generic.Device device */ 15:
                    message.device = Device.internalBinaryRead(reader, reader.uint32(), options, message.device);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Source source */ 16:
                    message.source = Source.internalBinaryRead(reader, reader.uint32(), options, message.source);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Location location */ 17:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.SubGrowth sub_growth */ 18:
                    message.sub_growth = SubGrowth.internalBinaryRead(reader, reader.uint32(), options, message.sub_growth);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Growth growth */ 19:
                    message.growth = Growth.internalBinaryRead(reader, reader.uint32(), options, message.growth);
                    break;
                case /* repeated fubo.tv.proto.common.v3.generic.Cohorting cohorting */ 20:
                    message.cohorting.push(Cohorting.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UiInteraction_Properties, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* fubo.tv.proto.common.v3.generic.Core core = 1; */
        if (message.core)
            Core.internalBinaryWrite(message.core, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Attribute attribute = 2; */
        if (message.attribute)
            UiInteraction_Attribute.internalBinaryWrite(message.attribute, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* fubo.tv.proto.common.v3.generic.FuboContext fubo_context = 3; */
        if (message.fubo_context)
            FuboContext.internalBinaryWrite(message.fubo_context, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.UserProperties user_properties = 4; */
        if (message.user_properties)
            UserProperties.internalBinaryWrite(message.user_properties, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.AppContext app_context = 5; */
        if (message.app_context)
            AppContext.internalBinaryWrite(message.app_context, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Navigation navigation = 6; */
        if (message.navigation)
            Navigation.internalBinaryWrite(message.navigation, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Ui ui = 7; */
        if (message.ui)
            Ui.internalBinaryWrite(message.ui, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Program program = 8; */
        if (message.program)
            Program.internalBinaryWrite(message.program, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Sport sport = 9; */
        if (message.sport)
            Sport.internalBinaryWrite(message.sport, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.League league = 10; */
        if (message.league)
            League.internalBinaryWrite(message.league, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Team team = 11; */
        if (message.team)
            Team.internalBinaryWrite(message.team, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Genre genre = 12; */
        if (message.genre)
            Genre.internalBinaryWrite(message.genre, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Asset asset = 13; */
        if (message.asset)
            Asset.internalBinaryWrite(message.asset, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Channel channel = 14; */
        if (message.channel)
            Channel.internalBinaryWrite(message.channel, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* fubo.tv.proto.common.v3.generic.Device device = 15; */
        if (message.device)
            Device.internalBinaryWrite(message.device, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Source source = 16; */
        if (message.source)
            Source.internalBinaryWrite(message.source, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Location location = 17; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.SubGrowth sub_growth = 18; */
        if (message.sub_growth)
            SubGrowth.internalBinaryWrite(message.sub_growth, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Growth growth = 19; */
        if (message.growth)
            Growth.internalBinaryWrite(message.growth, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* repeated fubo.tv.proto.common.v3.generic.Cohorting cohorting = 20; */
        for (let i = 0; i < message.cohorting.length; i++)
            Cohorting.internalBinaryWrite(message.cohorting[i], writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.features.growth.v3.tracking.UiInteraction.Properties
 */
export const UiInteraction_Properties = new UiInteraction_Properties$Type();
